export enum ViewPosition {
	Default = 'J',
	FrontView = 'F',
	QuickAccess = 'Q',
	Any = 'ViewPositionAny'
}
